import React, { useEffect, useState } from "react";
import { Tab, Nav, Row } from 'react-bootstrap';
import { SelectCallback } from '@restart/ui/cjs/types';
import Col from 'react-bootstrap/Col';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Navbar from 'react-bootstrap/Navbar';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import "./Tabs.css";
import NavBar from "../NavBar/NavBar";


interface TabProps {
    name: string,
    component: () => React.ReactElement,
    enabled: boolean
}

interface TabsProps {
    tabs: TabProps[];
    activeKey: string;
    defaultActiveKey: string;
    onSelect: SelectCallback;
}

export default function Tabs(props: TabsProps) {
    const [tabKey, setTabKey] = React.useState(props.defaultActiveKey);


    const onSelectDefault: SelectCallback = (k, e) => { if (k !== null) setTabKey(k) }
    const onSelect = props.onSelect ?? onSelectDefault;

    useEffect(() => {
        setTabKey(props.activeKey);
    }, [props.activeKey])

    if (props.tabs.length === 0) {
        return (<p>No Tabs Defined</p>);
    }

    const tabs = props.tabs.filter(tab => tab.enabled).map((tab, index) => (
        <Tab.Pane key={"tab_content_" + index.toString()} eventKey={tab.name}>
            <Card>
                <Card.Header className="d-lg-none d-block" style={{ padding: "1em" }}>
                    {tab.name}
                </Card.Header>
                <Card.Body>
                    <tab.component />
                </Card.Body>
            </Card>
        </Tab.Pane>
    ))


    return (
        <Tab.Container mountOnEnter={false} unmountOnExit={false} id="controlTabs" defaultActiveKey={props.defaultActiveKey} activeKey={tabKey} onSelect={onSelect}>
            <Row>
                <Col className="d-none d-lg-block" style={{ backgroundColor: "#D8DBDF", paddingRight: "0px", minHeight: "100vh" }} lg={2}>
                    <Nav variant="tabs" fill className="justify-content-between" style={{ paddingTop: "1em" }}>
                        {
                            props.tabs.map((tab, index) => (
                                <Nav.Item key={"tab_header_" + index.toString()} style={{ left: "0px", right: "0px", width: "100%" }}>
                                    <Nav.Link eventKey={tab.name} disabled={!tab.enabled}>{tab.name}</Nav.Link>
                                </Nav.Item>
                            ))
                        }
                    </Nav>
                </Col>

                <Col style={{ marginRight: "1em" }}>
                    <Tab.Content style={{ marginLeft: "0px", marginRight: "0px", width: "auto", marginTop: "1em", }}>
                        {
                            tabs
                        }
                    </Tab.Content>
                </Col>
            </Row>
        </Tab.Container>
    );
}
